import type { ComponentPropsWithRef } from 'react'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import styles from './Drawer.module.css'

interface ItemProps extends ComponentPropsWithRef<'button'> {
  title: string
  isActive: boolean
  hasActiveSibling: boolean
  placeholder?: string
  counter?: number
  additionalSelectedItems?: number
  selectionFormattedText?: string
  biggerBreakpoint?: boolean
}

export function Item(props: ItemProps) {
  const {
    ref,
    title,
    placeholder,
    counter,
    isActive,
    hasActiveSibling,
    additionalSelectedItems,
    selectionFormattedText,
    biggerBreakpoint,
    className,
    ...rest
  } = props

  return (
    <button
      type="button"
      ref={ref}
      className={cn(
        styles.item,
        biggerBreakpoint ? styles.breakpointL : styles.breakpointM,
        isActive && styles.active,
        hasActiveSibling && styles.hasActiveSibling,
        className,
      )}
      {...rest}
    >
      <div className={styles.scrollableContainer}>
        <Typography variant="body-s-bold-tight">{title}</Typography>
        <div className={styles.selectionTextWrapper}>
          {selectionFormattedText
            ? (
                <Typography variant="body-m-regular-tight" as="p" className={styles.selectionText}>
                  {selectionFormattedText}
                </Typography>
              )
            : (
                <Typography variant="body-m-regular-tight" as="p" className={styles.placeholderText}>
                  {placeholder}
                </Typography>
              )}

          <Typography variant="body-m-regular-tight" as="p">
            {additionalSelectedItems && additionalSelectedItems > 0 && `+${additionalSelectedItems}`}
          </Typography>

          {counter && counter > 0
            ? (
                <Typography variant="body-s-regular-tight" as="p">
                  {`+${counter}`}
                </Typography>
              )
            : null}
        </div>
      </div>
      <Icon
        glyph="ChevronDown"
        size={20}
        className={biggerBreakpoint ? styles.triggerIconAtL : styles.triggerIconAtM}
      />
    </button>
  )
}
